<template>
  <div class="modal-container">
    <h1>Data Correction</h1>
    <div>
      <span class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <div class="custom-select" style="width: 300px">
                <label for="error_type-select"
                  >Please select process type.</label
                >
                <select
                  class="form-control"
                  id="error_select"
                  v-model="selected"
                  @change="handleChange"
                >
                  <option value="merge_people">
                    Merge two people into one
                  </option>
                  <option value="merge">Merge two stages into one race</option>
                  <option value="merge_can">
                    Merge two candidates into one
                  </option>
                  <option value="move_can">
                    Move a candidate to a different race
                  </option>
                  <option value="split_a_race">Split a race</option>
                  <option value="delete_candidates">Delete candidates</option>
                  <option value="delete_races">Delete races</option>
                  <option value="merge_organizations">Merge two organizations into one</option>
                  <option value="merge_offices">Merge two offices into one</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>

    <div class="modal-body">
      <!-- ERROR MESSAGE -->
      <div v-if="this.error_msg">
        <div>
          <p style="color:red; font">
            <b>{{ error_msg }}</b>
          </p>
        </div>
      </div>
      <!-- MERGE PEOPLE -->
      <div v-if="this.processType == 'merge_people'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerMerge }}</i></b
            >
          </p>
        </div>
         <div class="col-4 list-group-item" v-if="merge_people_response">
        <h2>Merge results</h2>
        <p class="action-results">
          {{ merge_people_response }}
        </p>
  </div>
        <div class="input-group">
          <input
            v-model="receiving_person"
            type="text"
            class="form-control col-md-3"
            placeholder="Person id of the person to keep"
            v-on:change="reset_merge_person"
            :disabled="jsonstr_person_differences"
          />
          <span class="input-group-addon"> </span>
          <input
            v-model="person_to_merge"
            type="text"
            class="form-control col-md-3"
            placeholder="Person id of the person to delete"
            v-on:change="reset_merge_person"
            :disabled="jsonstr_person_differences"
          />
        </div>
        <br />
        <ActionButtons
          :key="mergePeopleButtonsKey"
          :show-preview="!jsonstr_person_differences && !merge_people_fk_usage"
          :show-execute="!!jsonstr_person_differences || !!merge_people_fk_usage"
          :show-reset="!!jsonstr_person_differences || !!merge_people_fk_usage"
          preview-label="Preview merge"
          execute-label="Execute merge"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-link"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          @preview="getDataToMergePeople"
          @execute="merge_people_data"
          @reset="reset_cancel"
        />

        <div
          v-if="Array.isArray(merge_people_fk_usage) && merge_people_fk_usage.length"
          class="table-responsive merge-people-table"
        >
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th colspan=2 style="text-align: center;"> Tables that reference the person to be deleted </th>
              <tr>
                <th scope="col">Table Name</th>
                <th scope="col">Record IDs</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in merge_people_fk_usage" :key="row.table">
                <th scope="row">{{ row.table }}</th>
                <td>{{ row.table_ids }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-if="Array.isArray(jsonstr_person_differences) && jsonstr_person_differences.length"
          class="table-responsive merge-people-table"
        >
          <table class="table table-bordered table-sm">
            <thead>
                <tr>
                <th colspan=3 style="text-align: center;"> People table differences </th>
              <tr>
              <tr>
                <th scope="col">Field</th>
                <th
                  v-for="column in mergePeopleColumns"
                  :key="column.key"
                  scope="col"
                >
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in jsonstr_person_differences"
                :key="row.field"
              >
                <th scope="row">{{ row.field }}</th>
                <td
                  v-for="column in mergePeopleColumns"
                  :key="column.key"
                >
                  {{ row[column.key] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />
      </div>
      <!-- MERGE ENTITIES (ANY TWO RECORDS) -->
      <div v-if="this.processType == 'merge_organizations' || this.processType == 'merge_offices'" class="container">
         <div>
          <p>
            <b
              ><i>{{ pageDisclaimerMerge }}</i></b
            >
          </p>
        </div>
         <div class="col-4 list-group-item" v-if="merge_entities_response">
        <h2>Merge results</h2>
        <p class="action-results">
          {{ merge_entities_response }}
        </p>
  </div>
        <div class="input-group">
          <input
            v-model="receiving_entity"
            type="text"
            class="form-control col-md-3"
            placeholder="Id of the record to keep"
            v-on:change="reset_merge_entity"
            :disabled="jsonstr_entity_differences"
          />
          <span class="input-group-addon"> </span>
          <input
            v-model="entity_to_merge"
            type="text"
            class="form-control col-md-3"
            placeholder="Id of the record to delete"
            v-on:change="reset_merge_entity"
            :disabled="jsonstr_entity_differences"
          />
        </div>
        <br />
        <ActionButtons
          :key="mergeEntitiesButtonsKey"
          :show-preview="!jsonstr_entity_differences && !merge_entities_fk_usage"
          :show-execute="!!jsonstr_entity_differences || !!merge_entities_fk_usage"
          :show-reset="!!jsonstr_entity_differences || !!merge_entities_fk_usage"
          preview-label="Preview merge"
          execute-label="Execute merge"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-link"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          @preview="getDataToMergeEntities"
          @execute="merge_entities_data"
          @reset="reset_cancel"
        />

        <div
          v-if="Array.isArray(merge_entities_fk_usage) && merge_entities_fk_usage.length"
          class="table-responsive merge-organization-table"
        >
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th colspan=2 style="text-align: center;"> Tables that reference the record to be deleted </th>
              <tr>
                <th scope="col">Table Name</th>
                <th scope="col">Record IDs</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in merge_entities_fk_usage" :key="row.table">
                <th scope="row">{{ row.table  }}</th>
                <td>{{ row.table_ids }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          v-if="Array.isArray(jsonstr_entity_differences) && jsonstr_entity_differences.length"
          class="table-responsive merge-organization-table"
        >
          <table class="table table-bordered table-sm">
            <thead>
                <tr>
                <th colspan=3 style="text-align: center;">Table differences </th>
              <tr>
              <tr>
                <th scope="col">Field</th>
                <th
                  v-for="column in mergeEntityColumns"
                  :key="column.key"
                  scope="col"
                >
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in jsonstr_entity_differences"
                :key="row.field"
              >
                <th scope="row">{{ row.field }}</th>
                <td
                  v-for="column in mergeEntityColumns"
                  :key="column.key"
                >
                  {{ row[column.key] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />
      </div>








      <!-- MERGE RACES -->
      <div v-if="this.processType == 'merge'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerMerge }}</i></b
            >
          </p>
        </div>
        <div class="input-group">
          <input
            v-model="receiving_race"
            type="text"
            class="form-control col-md-3"
            placeholder="Race id of merge-into race"
            v-on:change="reset_merge"
            :disabled="jsonstr_to_merge"
          />
          <span class="input-group-addon"> </span>
          <input
            v-model="race_to_merge"
            type="text"
            class="form-control col-md-3"
            placeholder="Race id of race to merge"
            v-on:change="reset_merge"
            :disabled="jsonstr_to_merge"
          />
        </div>
        <br />
        <ActionButtons
          :show-preview="!jsonstr_receiving"
          :show-execute="!!jsonstr_to_merge"
          :show-reset="!!jsonstr_to_merge"
          preview-label="Preview merge"
          execute-label="Execute merge"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-link"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          @preview="getDataToMerge"
          @execute="merge_data"
          @reset="reset_cancel"
        />

        <br />
      </div>
      <!-- MERGE Candidates -->
      <div v-if="this.processType == 'merge_can'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerExplanation }}</i></b
            >
          </p>
        </div>
        <div class="input-group">
          <input
            v-model="receiving_can"
            type="text"
            class="form-control col-md-3"
            placeholder="Candidate id that will remain"
            v-on:change="reset_merge_can"
            :disabled="jsonstr_to_merge_can"
          />
          <span class="input-group-addon"> </span>
          <input
            v-model="can_to_merge"
            type="text"
            class="form-control col-md-3"
            placeholder="Candidate id that will be merged"
            v-on:change="reset_merge_can"
            :disabled="jsonstr_to_merge_can"
          />
        </div>
        <br />
        <ActionButtons
          :show-preview="!jsonstr_receiving_can"
          :show-execute="!!jsonstr_to_merge_can"
          :show-reset="!!jsonstr_to_merge_can"
          preview-label="Preview merge"
          execute-label="Execute merge"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-link"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          @preview="getDataToMergeCan"
          @execute="merge_can_data"
          @reset="reset_cancel"
        />

        <br />
      </div>
      <!-- Move Candidates -->
      <div v-if="this.processType == 'move_can'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerExplanation }}</i></b
            >
          </p>
        </div>
        <div class="input-group">
          <input
            v-model="can_to_move"
            type="text"
            class="form-control col-md-3"
            placeholder="Candidate to move"
            v-on:change="reset_move_can"
            :disabled="jsonstr_can_to_move"
          />
          <span class="input-group-addon"> </span>
          <input
            v-model="race_to_move_to"
            type="text"
            class="form-control col-md-3"
            placeholder="Race to which candidate will be moved"
            v-on:change="reset_move_can"
            :disabled="jsonstr_race_to_move_to"
          />
        </div>
        <br />
        <ActionButtons
          :show-preview="!jsonstr_can_to_move"
          :show-execute="!!jsonstr_can_to_move"
          :show-reset="!!jsonstr_can_to_move"
          preview-label="Preview move"
          execute-label="Execute move"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-link"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          @preview="getDataToMoveCan"
          @execute="move_can_data"
          @reset="reset_cancel"
        />

        <br />
      </div>
      <!-- Delete Candidates -->
      <div v-if="this.processType == 'delete_candidates'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerExplanation }}</i></b
            >
          </p>
        </div>
        <div>
          <input
            v-model="candidate_ids"
            type="text"
            class="form-control"
            placeholder="List of candidate ids to delete"
            v-on:change="reset_candidate_list"
            :disabled="jsonstr_candidates"
          />
        </div>
        <br />
        <ActionButtons
          :show-preview="!jsonstr_candidates"
          :show-execute="!!jsonstr_candidates"
          :show-reset="!!jsonstr_candidates"
          preview-label="Preview candidates"
          execute-label="Delete candidates"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-trash"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          :button-width="'160px'"
          @preview="getCandidatesToDelete"
          @execute="deleteCandidates"
          @reset="reset_cancel"
        />
      </div>
      <!-- DELETE RACES -->
      <div v-if="this.processType == 'delete_races'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerExplanation }}</i></b
            >
          </p>
        </div>
        <div>
          <input
            v-model="race_ids"
            type="text"
            class="form-control"
            placeholder="List of race ids to delete"
            v-on:change="reset_race_list"
            :disabled="jsonstr_races"
          />
        </div>
        <br />
        <ActionButtons
          :show-preview="!jsonstr_races"
          :show-execute="!!jsonstr_races"
          :show-reset="!!jsonstr_races"
          preview-label="Preview races"
          execute-label="Delete races"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-trash"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          :button-width="'160px'"
          @preview="getRacesToDelete"
          @execute="deleteRaces"
          @reset="reset_cancel"
        />
      </div>
      <!-- SPLIT RACES -->
      <div v-if="this.processType == 'split_a_race'" class="container">
        <div>
          <p>
            <b
              ><i>{{ pageDisclaimerExplanation }}</i></b
            >
          </p>
        </div>
        <input
          v-model="race_to_split_id"
          type="text"
          class="form-control"
          placeholder="Race ID of race to split"
          v-on:change="reset_split_list"
          :disabled="split_data"
        />

        <br />
        <ActionButtons
          :show-preview="!split_data"
          :show-execute="!!split_data"
          :show-reset="!!split_data"
          preview-label="Get race data"
          execute-label="Execute split"
          reset-label="Reset"
          preview-icon="fa fa-glasses"
          execute-icon="fa fa-arrows-split-up-and-left"
          reset-icon="fa fa-times"
          :execute-disabled="isDisabled"
          :button-width="'160px'"
          @preview="getRaceToSplit"
          @execute="splitData"
          @reset="reset_cancel"
        />
      </div>
      <!-- MERGE DISPLAY -->
      <div class="col-4 list-group-item" v-if="merge_response">
        <h3>Merge results</h3>
        <p class="action-results">
          {{ merge_response }}
        </p>
      </div>

      <div
        class="container text-left"
        v-if="jsonstr_receiving"
        id="display_merge_data"
      >
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecuteMerge }}</b>
        </p>
        <br />
        <div class="row align-items-start">
          <DataPreview
            class="col-4"
            title="Merge Into Race Information"
            :items="jsonstr_receiving"
          />
          <DataPreview
            class="col-4"
            title="Merge From Race Information"
            :items="jsonstr_to_merge"
          />
        </div>
      </div>
      <!-- MERGE PEOPLE DISPLAY -->


      <!-- MERGE CAN DISPLAY -->
      <div class="col-4 list-group-item" v-if="merge_can_response">
        <h2>Merge results</h2>
        <p class="action-results">
          {{ merge_can_response }}
        </p>
      </div>

      <div
        class="container text-left"
        v-if="jsonstr_receiving_can"
        id="display_merge_data"
      >
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecute }}</b>
        </p>
        <br />
        <div class="row align-items-start">
          <DataPreview
            class="col-4"
            :title="labelWithValue('Candidate To Remain', receiving_can)"
            :items="jsonstr_receiving_can"
          />
          <DataPreview
            class="col-4"
            :title="labelWithValue('Candidate To Merge', can_to_merge)"
            :items="jsonstr_to_merge_can"
          />
        </div>
      </div>
      <!-- MOVE CAN DISPLAY -->
      <div class="col-4 list-group-item" v-if="move_can_response">
        <h2>Move results</h2>
        <p class="action-results">
          {{ move_can_response }}
        </p>
      </div>

      <div
        class="container text-left"
        v-if="jsonstr_can_to_move"
        id="display_move_data"
      >
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecute }}</b>
        </p>
        <br />
        <div class="row align-items-start">
          <DataPreview
            class="col-4"
            :title="labelWithValue('Candidate To Move', can_to_move)"
            :items="jsonstr_can_to_move"
          />
          <DataPreview
            class="col-4"
            title="Race to move to"
            :items="jsonstr_race_to_move_to"
          />
        </div>
      </div>
      <!-- CANDIDATES DISPLAY -->
      <div class="col-4 list-group-item" v-if="candidate_response">
        <h2>Candidate delete result</h2>
        <p class="action-results">
          {{ candidate_response["data"][0]["ul_delete_candidates"] }}
        </p>
      </div>
      <div
        class="container text-left"
        v-if="jsonstr_candidates"
        id="display_candidate_data"
      >
        <br />
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecute }}</b>
        </p>
        <br />
        <div class="row align-items-start">
          <DataPreview
            class="col-4"
            title="Candidate Information"
            :items="jsonstr_candidates"
          />
        </div>
      </div>
      <!-- RACES DISPLAY -->
      <div class="col-4 list-group-item" v-if="race_response">
        <h2>Race delete result</h2>
        <p class="action-results">
          {{ race_response["data"][0]["ul_delete_races"] }}
        </p>
      </div>
      <div
        class="container text-left"
        v-if="jsonstr_races"
        id="display_race_data"
      >
        <br />
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecute }}</b>
        </p>
        <br />
        <div class="row align-items-start">
          <DataPreview
            class="col-4"
            title="Race Information"
            :items="jsonstr_races"
          />
        </div>
      </div>
      <!-- SPLIT DISPLAY -->
      <div class="col-4 list-group-item" v-if="split_races_created.length > 0">
        <h2>Split result</h2>
        <p>The following race ids were modified or created in this process</p>
        <div v-for="item in split_races_created" :key="item">
          <p>{{ item }}</p>
        </div>
      </div>
      <div v-if="split_data">
        <br />
        <p class="disclaimer-execute">
          <b>{{ pageDisclaimerExecute }}</b>
        </p>
        <br />
        <h2 class="table-name" style="margin-bottom: 0">Race to split</h2>

        <br />
        <HandsOnTable
          class="table"
          :data="split_data"
          :settings="settings"
          :columns="columnMetaData"
          ref="hot"
        >
        </HandsOnTable>
      </div>
    </div>
  </div>
</template>
<script>
import HandsOnTable from "./HandsOnTable.vue";
import ActionButtons from "./shared/ActionButtons.vue";
import DataPreview from "./shared/DataPreview.vue";
import getColumnMetaData from "../mixins/columnMetaData.js";
import getPageDisclaimer from "../mixins/pageDisclaimers.js";

export default {
  name: "ErrorProcessing",
  components: {
    HandsOnTable,
    ActionButtons,
    DataPreview,
  },
  mixins: [getColumnMetaData, getPageDisclaimer],

  data: function () {
    return {
      settings: {
        startRows: 1,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 500,
        comments: true,
      },
      columnMetaData: [],
      selected: null,
      processType: null,
      receiving_race: null,
      receiving_can: null,
      receiving_person: null,
      receiving_entity: null,
      entity_to_merge: null,
      merge_entities_response: null,
      mergeEntitiesButtonsKey: 0,
      merge_entities_buttons_key: 0,
      merge_people_buttons_key: 0,
      mergePeopleButtonsKey: 0,
      race_to_merge: null,
      can_to_merge: null,
      person_to_merge: null,
      race_to_move_to: null,
      can_to_move: null,
      pageDisclaimerMerge: null,
      pageDisclaimerExecuteMerge: null,
      pageDisclaimerExplanation: null,
      jsonstr_receiving: null,
      jsonstr_receiving_can: null,
      jsonstr_person_differences: null,
      merge_people_fk_usage: null,
      merge_entities_fk_usage: null,
      jsonstr_to_merge: null,
      jsonstr_to_merge_can: null,
      jsonstr_to_merge_person: null,
      jsonstr_candidates: null,
      jsonstr_races: null,
      jsonstr_can_to_move: null,
      jsonstr_race_to_move_to: null,
      candidate_ids: null,
      race_ids: null,
      split_data: null,
      race_to_split_id: null,
      table: "ultralocal.ul_split_races",
      merge_response: null,
      merge_can_response: null,
      merge_people_response: null,  
      mergePeopleButtonsKey: 0,
      split_races_created: [],
      candidate_response: null,
      race_response: null,
      error_msg: null,
      isDisabled: false,
      executeLockActive: false,
      move_can_response: null
    };
  },
  computed: {
    mergePeopleColumns() {
      const keepId = ((this.receiving_person || "") + "").trim();
      const mergeId = ((this.person_to_merge || "") + "").trim();

      return [
        {
          key: "personToKeep",
          label: keepId || "Person To Keep",
        },
        {
          key: "personToDelete",
          label: mergeId || "Person To Replace",
        },
      ];
    },
  
   mergeEntityColumns() {
      const keepId = ((this.receiving_entity || "") + "").trim();
      const mergeId = ((this.entity_to_merge || "") + "").trim();

      return [
        {
          key: "recordToKeep",
          label: keepId || "Record To Keep",
        },
        {
          key: "recordToDelete",
          label: mergeId || "Record To Replace",
        },
      ];
    },
  },
  
  methods: {
    reset() {
      this.reset_merge();
      this.reset_merge_can();
      this.reset_race_list();
      this.reset_candidate_list();
      this.reset_split_list();
      this.reset_move_can();
      this.reset_merge_person();
      this.reset_merge_entity();
      this.receiving_race = null;
      this.race_to_merge = null;
      this.receiving_can = null;
      this.can_to_merge = null;
      this.receiving_person = null;
      this.person_to_merge = null;
      this.can_to_move = null;
      this.race_to_move_to = null;
      this.pageDisclaimerMerge = null;
      this.pageDisclaimerExecuteMerge = null;
      this.pageDisclaimerExplanation = null;
      this.candidate_ids = null;
      this.race_ids = null;
      this.race_to_split_id = null;
      this.error_msg = null;
  this.isDisabled = false;
  this.executeLockActive = false;

    },
    reset_merge() {
      this.jsonstr_receiving = null;
      this.jsonstr_to_merge = null;
      this.merge_response = null;
    },
    reset_merge_can() {
      this.jsonstr_receiving_can = null;
      this.jsonstr_to_merge_can = null;
      this.merge_can_response = null;
    },
    reset_merge_person() {
      this.jsonstr_receiving_person= null;
      this.jsonstr_to_merge_person = null;
      this.merge_person_response = null;
      this.jsonstr_person_differences = null;
      this.merge_people_fk_usage = null;
      this.merge_people_response = null;
     },
      reset_merge_entity() {
      this.jsonstr_receiving_entity= null;
      this.jsonstr_to_merge_entity = null;
      this.merge_entities_response = null;
      this.jsonstr_entity_differences = null;
      this.merge_entities_fk_usage = null;
      this.merge_entities_response = null;
      this.error_msg = null;
     },
     reset_move_can() {
      this.jsonstr_can_to_move = null;
      this.jsonstr_race_to_move_to = null;
      this.move_can_response = null;
    },
    reset_race_list() {
      this.jsonstr_races = null;
      this.race_response = null;
    },
    reset_candidate_list() {
     
      this.jsonstr_candidates = null;
      this.candidate_response = null;
    },
    reset_split_list() {
     
      this.split_data = null;
      this.split_races_created = [];
    },
    reset_cancel() {
      this.reset_merge();
      this.reset_merge_can();
      this.reset_move_can();
      this.reset_race_list();
      this.reset_candidate_list();
      this.reset_split_list();
      this.reset_merge_person();
      this.reset_merge_entity();
      this.isDisabled = false;
      this.executeLockActive = false;
      this.receiving_race = null;
      this.race_to_merge = null;
      this.candidate_ids = null;
      this.race_ids = null;
      this.race_to_split_id = null;
      this.merge_people_fk_usage = null;
    },

    labelWithValue(label, value) {
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed) {
          return `${label} (${trimmed})`;
        }
      }
      return label;
    },

    async handleChange(e) {
      this.reset();
      if (e.target.options.selectedIndex > -1) {
        this.processType =
          e.target.options[e.target.options.selectedIndex].value;
      }
      if (this.processType == "merge") {
        this.pageDisclaimerMerge = await this.getPageDisclaimer(
          "data_correction_merge"
        );
        this.pageDisclaimerExecuteMerge = await this.getPageDisclaimer(
          "data_correction_execute_merge"
        );
      }
      if (this.processType == "merge_can") {
        this.pageDisclaimerExplanation = await this.getPageDisclaimer(
          "data_correction_merge_candidates"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_merge_candidates"
        );
      }
       if (this.processType == "merge_people") {
        this.pageDisclaimerMerge = await this.getPageDisclaimer(
          "data_correction_merge_people"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_merge_candidates"
        );
      }
       if (this.processType == "merge_organizations" || this.processType == "merge_offices") {
        this.pageDisclaimerMerge = await this.getPageDisclaimer(
          "data_correction_merge_entities"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_merge_candidates"
        );
      }
      if (this.processType == "move_can") {
        this.pageDisclaimerExplanation = await this.getPageDisclaimer(
          "data_correction_move_candidates"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_move_candidates"
        );
      }
      if (this.processType == "delete_candidates") {
        this.pageDisclaimerExplanation = await this.getPageDisclaimer(
          "data_correction_delete_candidate"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_delete_candidates"
        );
      }
      if (this.processType == "delete_races") {
        this.pageDisclaimerExplanation = await this.getPageDisclaimer(
          "data_correction_delete_races"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_delete_races"
        );
      }
      if (this.processType == "split_a_race") {
        this.pageDisclaimerExplanation = await this.getPageDisclaimer(
          "data_correction_split_races"
        );
        this.pageDisclaimerExecute = await this.getPageDisclaimer(
          "data_correction_execute_split_races"
        );
       
      }
    },
    async getDataToMergeEntities() {
      let type_of_merge = null;
      if (this.processType === 'merge_organizations'){
          type_of_merge = 'organizations'
      } else if (this.processType === 'merge_offices'){
          type_of_merge = 'offices'
      }
        if (this.receiving_entity){
          this.receiving_entity = (this.receiving_entity).trim()
         }
         if (this.entity_to_merge){
          this.entity_to_merge = (this.entity_to_merge).trim()
         }
         if (!this.receiving_entity || !this.entity_to_merge){
          this.error_msg = 'Please enter both an entity to keep and an entity to replace';
          return;
        }
       
       let entities_params = {
        receiving_entity: this.receiving_entity,
        entity_to_merge: this.entity_to_merge,
        type_of_merge: type_of_merge

      };
    
      let response = await this.executeProcedure(
        "data_correction/compare_entity_records",
        JSON.stringify(entities_params)
      );
      if (response['success'] === false){
        this.error_msg = response['message'];
        return;
      }
      if (response['data']){
       this.merge_entity_response = response["data"];
      } else {
        this.merge_entity_response = response.message
      }
    
      this.jsonstr_entity_differences = await this.format_merge_any_two_records_for_display(
        this.merge_entity_response
      );
      
      this.merge_entities_fk_usage = [];
      response = await this.executeProcedure(
        "data_correction/get_entity_fk_usage",
        JSON.stringify(entities_params)
      );
      
      if (response["data"]) {
        this.merge_entities_fk_usage = await this.format_entities_fk_replace_data_for_display(
          response["data"]
        );
      } else if (response && response.message) {
        this.error_msg = response.message;
      }
      this.merge_response = null;
      
    },
    async getDataToMergePeople() {
        if (this.receiving_person){
          this.receiving_person = (this.receiving_person).trim()
         }
         if (this.person_to_merge){
          this.person_to_merge = (this.person_to_merge).trim()
         }
         if (!this.receiving_person || !this.person_to_merge){
          this.error_msg = 'Please enter both a person to keep and a person to replace';
          return;
        }
       
       let people_params = {
        receiving_person: this.receiving_person,
        person_to_merge: this.person_to_merge,
      };
    
      let response = await this.executeProcedure(
        "data_correction/compare_people_records",
        JSON.stringify(people_params)
      );
      if (response['success'] === false){
        this.error_msg = response['message'];
        return;
      }
      if (response['data']){
       this.merge_person_response = response["data"];
      } else {
        this.merge_person_response = response.message
      }
      this.jsonstr_person_differences = await this.format_merge_people_data_for_display(
        this.merge_person_response
      );
    
      this.merge_people_fk_usage = [];
      response = await this.executeProcedure(
        "data_correction/get_person_fk_usage",
        JSON.stringify(people_params)
      );
      if (response["data"]) {
        this.merge_people_fk_usage = await this.format_people_fk_replace_data_for_display(
          response["data"]
        );
      } else if (response && response.message) {
        this.error_msg = response.message;
      }
      this.merge_response = null;
      
    },
    async getDataToMerge() {
      this.error_msg = null;
      //build the query to get the csr data for both races.
     
      if (this.receiving_race){
        this.receiving_race = (this.receiving_race).trim()
      }
      if (this.race_to_merge){
        this.race_to_merge = (this.race_to_merge).trim()
      }
      if (!this.receiving_race || !this.race_to_merge){
        this.error_msg = 'Please enter both a merge-into race and a race to merge';
        return;
      }
      let races = `${this.receiving_race}, ${this.race_to_merge}`;

      let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->'race'->>'id'","selectedOperator":"in_num","selectedOperand":"Race ID","value":"${races}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":null,"isCountOnly":false}`;

      let my_response = await this.getFilteredData(query);
     
      let my_data = my_response.data;

      let receiving_race = this.receiving_race;
      let race_to_merge = this.race_to_merge;

      let receiving_race_data = my_data.filter(function (el) {
        return el.candidate.race.id == receiving_race;
      });
      let race_to_marge_data = my_data.filter(function (el) {
        return el.candidate.race.id == race_to_merge;
      });
      this.jsonstr_receiving = await this.format_merge_data_for_display(
        receiving_race_data
      );
      this.jsonstr_to_merge = await this.format_merge_data_for_display(
        race_to_marge_data
      );
    },
    async merge_data() {
      
      
      let merge_params = {
        receiving_race: this.receiving_race,
        race_to_merge: this.race_to_merge,
      };
       
      let response = await this.executeProcedure(
        "data_correction/merge_races",
        JSON.stringify(merge_params),
        { lockExecuteButton: true }
      );
      if (response['data']){
       this.merge_response = response["data"][0]["merge_two_races"];
      } else {
        this.merge_response = response.message
      }
    },
    async getDataToMergeCan() {
      this.error_msg = null;
      //build the query to get the csr data for both candidates.
      
      if (this.receiving_can){
        this.receiving_can = (this.receiving_can).trim()
      }
      if (this.can_to_merge_to_merge){
        this.can_to_merge_to_merge = (this.can_to_merge).trim()
      }
      if (!this.receiving_can || !this.can_to_merge){
        this.error_msg = 'Please enter both a candidate to remain and a candidate to merge';
        return;
      }
      let candidates = `${this.receiving_can}, ${this.can_to_merge}`;
     
     let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->>'id'","selectedOperator":"in_num","selectedOperand":"Candidate ID","value":"${candidates}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":"candidate_stage_results_view.candidate->'person'->>'name' ","isCountOnly":false}`;
     
      let my_response = await this.getFilteredData(query);
      
      let my_data = my_response.data;

      let receiving_can = this.receiving_can;
      let can_to_merge = this.can_to_merge;

      let receiving_can_data = my_data.filter(function (el) {
        return el.candidate.id == receiving_can;
      });
      let can_merge_data = my_data.filter(function (el) {
        return el.candidate.id == can_to_merge;
      });
      this.jsonstr_receiving_can = await this.format_merge_data_for_display(
        receiving_can_data
      );
      this.jsonstr_to_merge_can = await this.format_merge_data_for_display(
        can_merge_data
      );
    },
    async merge_can_data(){
      let merge_params = {
        receiving_candidate: this.receiving_can,
        candidate_to_merge: this.can_to_merge,
      };
    
      let response = await this.executeProcedure(
        "data_correction/merge_candidates",
        JSON.stringify(merge_params),
        { lockExecuteButton: true }
      );
     
      if (response['data']){
          this.merge_can_response = response["data"][0]["merge_two_candidates"];
      }else{
        this.merge_can_response = response['message'];
      }
    },
    async merge_entities_data(){
      let type_of_merge = null;
      if (this.processType === 'merge_organizations'){
          type_of_merge = 'organizations'
      } else if (this.processType === 'merge_offices'){
          type_of_merge = 'offices'
      }
      let merge_params = {
        receiving_entity: this.receiving_entity,
        entity_to_merge: this.entity_to_merge,
        entity_type: type_of_merge
      };
    
      let response = await this.executeProcedure(
        "data_correction/merge_entities",
        JSON.stringify(merge_params),
        { lockExecuteButton: true }
      );
      if (response['success'] === false){
         this.error_msg = response['message'];
        return;
      }
      if (response['data']){
         this.merge_entities_response = response["data"][0]["update_entity_fk_usage"];
      }else{
        this.merge_entities_response = response['message'];
      }
     
    },
    async merge_people_data(){
    
      let merge_params = {
        receiving_person: this.receiving_person,
        person_to_merge: this.person_to_merge
      };
    
      let response = await this.executeProcedure(
        "data_correction/merge_people",
        JSON.stringify(merge_params),
        { lockExecuteButton: true }
      );
      if (response['success'] === false){
        this.error_msg = response['message'];
        return;
      }
      if (response['data']){
          this.merge_people_response = response["data"][0]["update_person_fk_usage"];
      }else{
        this.merge_people_response = response['message'];
      }
    
    },
    async format_merge_data_for_display(merge_data) {
      let data_array = [];
      await merge_data.forEach((item) => {
        let merge_object = {
          "Race ID": item.candidate.race.id,
          "Office Name": item.candidate.race.office.name,
          "Stage Type": item.stage.type,
          "Stage Party": item.stage.party,
          "Stage ID": item.stage.id,
          "Candidate's Name": item.candidate.person.name,
          "Candidate's Status": item.status,
        };
        data_array.push(merge_object);
      });

      return data_array;
    },
    async format_merge_people_data_for_display(merge_data) {
      if (!Array.isArray(merge_data) || !merge_data.length) {
        return [];
      }

      const records =
        merge_data[0] && merge_data[0].compare_people_records
          ? merge_data[0].compare_people_records
          : null;

      if (!records) {
        return [];
      }

      const rows = [];

      Object.keys(records).forEach((key) => {
        if (key === "created" || key === "updated") {
          return;
        }

        const value = records[key] || {};
        const keepValue = value.person_to_keep != null ? value.person_to_keep : "";
        const deleteValue = value.person_to_delete != null ? value.person_to_delete : "";

        if (!keepValue && !deleteValue) {
          return;
        }

        rows.push({
          field: key,
          personToKeep: keepValue,
          personToDelete: deleteValue,
        });
      });

      return rows;
    },
    async format_people_fk_replace_data_for_display(fk_data) {
      if (!Array.isArray(fk_data) || !fk_data.length) {
        return [];
      }

      const firstItem = fk_data[0];
      const records = firstItem && firstItem.get_person_fk_usage_json
        ? firstItem.get_person_fk_usage_json
        : null;

      if (!Array.isArray(records) || !records.length) {
        return [];
      }

      const rows = [];
      records.forEach((item) => {
        if (!item) {
          return;
        }

        rows.push({
          table: item.schema_name + '.' + item.table_name,
          table_ids: item.table_ids,
        });
      });

      return rows;
    },
   async format_entities_fk_replace_data_for_display(fk_data) {
      if (!Array.isArray(fk_data) || !fk_data.length) {
        return [];
      }
      
      const firstItem = fk_data[0];
      const records = firstItem && firstItem.get_entity_fk_usage_json
        ? firstItem.get_entity_fk_usage_json
        : null;
        
      if (!Array.isArray(records) || !records.length) {
        return [];
      }

      const rows = [];
      records.forEach((item) => {
        if (!item) {
          return;
        }
        
        rows.push({
          table: item.schema_name + '.' + item.table_name,
          table_ids: item.table_ids,
        });
      });

      return rows;
    },


 async format_merge_any_two_records_for_display(merge_data) {
      if (!Array.isArray(merge_data) || !merge_data.length) {
        return [];
      }

      const records =
        merge_data[0] && merge_data[0].compare_two_records
          ? merge_data[0].compare_two_records
          : null;

      if (!records) {
        return [];
      }

      const rows = [];

      Object.keys(records).forEach((key) => {
        if (key === "created" || key === "updated") {
          return;
        }

        const value = records[key] || {};
        const keepValue = value.record_to_keep != null ? value.record_to_keep : "";
        const deleteValue = value.record_to_delete != null ? value.record_to_delete : "";

        if (!keepValue && !deleteValue) {
          return;
        }

        rows.push({
          field: key,
          recordToKeep: keepValue,
          recordToDelete: deleteValue,
        });
      });

      return rows;
    },
 async getDataToMoveCan() {
      this.error_msg = null;
      //build the query to get the csr data for both candidates.
    
      if (this.can_to_move){
        this.can_to_move = (this.can_to_move).trim()
      }
      if (this.race_to_move_to){
        this.race_to_move_to = (this.race_to_move_to).trim()
      }
      if (!this.can_to_move || !this.race_to_move_to){
        this.error_msg = 'Please enter both a candidate to move and a race to move to';
        return;
      }
      let candidates = `${this.can_to_move}`;
      let races = `${this.race_to_move_to}`;
     let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->>'id'","selectedOperator":"in_num","selectedOperand":"Candidate ID","value":"${candidates}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":null,"isCountOnly":false}`;
     let my_response = await this.getFilteredData(query);
         
      let my_data = my_response.data;
               
      this.jsonstr_can_to_move = await this.format_candidate_data_for_display(
        my_data
      );
      //get the race info
       query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->'race'->>'id'","selectedOperator":"in_num","selectedOperand":"Race ID","value":"${races}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":"candidate_stage_results_view.candidate->'race'->>'id'","isCountOnly":false}`;
       my_response = await this.getFilteredData(query);
       this.jsonstr_race_to_move_to = await this.format_merge_data_for_display(my_response.data);
     
       
    },
    async move_can_data(){
     let move_params = {
       candidate: this.can_to_move,
       race: this.race_to_move_to,
      };
     let response = await this.executeProcedure(
        "data_correction/move_a_candidate",
        JSON.stringify(move_params),
        { lockExecuteButton: true }
      );
      
      if (response['data']){
         this.move_can_response = response["data"][0]["move_a_candidate"];
      }else{
        this.move_can_response = response.message
      }
    },
    async format_candidate_data_for_display(candidate_data) {
      
      let data_array = [];
      await candidate_data.forEach((item) => {
        let candidate_object = {
          "Candidate ID": item.candidate.id,
          "Race ID": item.candidate.race.id,
          "Office Name": item.candidate.race.office.name,
          "Stage Type": item.stage.type,
          "Stage Party": item.stage.party,
          "Stage ID": item.stage.id,
          "Candidate's Name": item.candidate.person.name,
          "Candidate's Status": item.status,
        };
        data_array.push(candidate_object);
      });  
      
      return data_array;
    },
    async getCandidatesToDelete() {
      this.error_msg = null;
      if (this.candidate_ids){
         this.candidate_ids = (this.candidate_ids).trim()
      }
      let candidates = (this.candidate_ids)
      if (!candidates){
        this.error_msg = 'Please enter at least one candidate id'
        return;
      }
      let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->>'id'","selectedOperator":"in_num","selectedOperand":"Candidate ID","value":"${candidates}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":"candidate_stage_results_view.candidate->>'id' ","isCountOnly":false}`;
      let my_response = await this.getFilteredData(query);
     
      let my_data = my_response.data;
      this.jsonstr_candidates = await this.format_candidate_data_for_display(
        my_data
      );
    },
    async getRacesToDelete() {
       this.error_msg = null;
      
      if (this.race_ids){
         this.race_ids = (this.race_ids).trim()
      }
      let races = this.race_ids;
      if (!races){
        this.error_msg = 'Please enter at least one race id'
        return;
      }
      let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"candidate_stage_results_view.candidate->'race'->>'id'","selectedOperator":"in_num","selectedOperand":"Race ID","value":"${races}"}}]},"table":"candidate_stage_results","limit":100,"offset":1,"orderBy":"candidate_stage_results_view.candidate->'race'->>'id'","isCountOnly":false}`;
      let my_response = await this.getFilteredData(query);
      
      let my_data = my_response.data;
      this.jsonstr_races = await this.format_merge_data_for_display(my_data);
    },
    async getRaceToSplit() {
      this.error_msg = null;
      this.columnMetaData = [];
      await this.generateColumnMetaData("Edit", this.table);
      
      if (this.race_to_split_id) {
        this.race_to_split_id = (this.race_to_split_id).trim()
      }
       if (!this.race_to_split_id){
        this.error_msg = 'Please enter a race to split'
        return;
      }
      let races = this.race_to_split_id;
      let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"ultralocal.ul_split_races_view.race->>'id'","selectedOperator":"in_num","selectedOperand":"Race ID","value":"${races}"}}]},"table":"ultralocal.ul_split_races","limit":100,"offset":1}`;
      let my_response = await this.getFilteredData(query);

      this.split_data = [];
      let i = 0;
      await my_response.data.forEach((item) => {
        i++;
        this.split_data.push(item);
      });

      await this.$refs.hot.$refs.hot.hotInstance.loadData(this.split_data);
    },
    //createDataDisplay(data) {},

    async getFilteredData(query) {
     
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: query,
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json();
      }
      
      return response;
    },
    async executeProcedure(procedure_name, data_in, options = {}) {
      const { lockExecuteButton = false } = options || {};
      this.isDisabled = true;
      if (lockExecuteButton) {
        this.executeLockActive = true;
      }
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        resource: `${process.env.VUE_APP_API4_DOMAIN}/${procedure_name}`,
      };

      try {
        const response = await fetch(
          `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
          {
            method: "POST",
            headers,
            credentials: "include",
            body: data_in,
          }
        );

        if (response.status === 403) {
          const payload = await response.json();
          alert(payload.message);
          window.location.href = "/login";
          return payload;
        }

        return await response.json();
      } finally {
        if (!lockExecuteButton && !this.executeLockActive) {
          this.isDisabled = false;
        }
      }
    },
    async splitData() {
      
      let offices = new Set();
      let this_position;
      for await (const item of this.$refs.hot.$refs.hot.hotInstance.getSourceData()) {
        this_position = item.race.position;
        if (this_position !== null) {
          this_position = this_position.trim()
          if (!this_position){
            this_position = 'null'
          }
        } 
        offices.add(
          `${item.office.id}$${this_position}$${item.race.number_of_seats}$${item.race.type}$${item.race.year}`
        );
        
      }
      
      this.split_races_created = [];
      let data = this.$refs.hot.$refs.hot.hotInstance.getSourceData();
      let office_attributes;

      for (const value of offices) {
        let office_to_process = {};
        let office_data;
        let stages;
      
        office_attributes = value.split("$");
                
        if (office_attributes[1] == "null") {
          office_attributes[1] = null;
        }
        
        office_data = data.filter(
          (arr) =>
            arr.office.id == office_attributes[0] &&
            (arr.race.position == office_attributes[1] || arr.race.position == '' && office_attributes[1] == null) &&
            arr.race.number_of_seats == office_attributes[2] &&
            arr.race.type == office_attributes[3] &&
            arr.race.year == office_attributes[4]
        );
        
        stages = office_data.reduce((c, { stage, election }) => {
          c[stage.id.toString()] = c[stage.id] || {
            key: stage.id,
            type: stage.type,
            party: stage.party_id,
            election: election.id,
          };

          return c;
        }, {});
         
        for (const this_stage in stages) {
          let candidates = {};
           
          candidates = office_data.reduce((c, { candidate, stage, office }) => {
            if (stage.id.toString() == this_stage)
              
            //c[candidate.id] = c[candidate.id] || {key:stage.id,type: stage.type, party: stage.party, office: office.id, position: office.position, num_seats: office.number_of_seats};
            c[candidate.id] = c[candidate.id] || { id: candidate.id };
            
            return c;
          }, {});
           
          //candidate_array.push(candidates)
           stages[this_stage].candidates = candidates;
        }
       
        office_to_process.office = parseInt(office_attributes[0]);
        office_to_process.position = office_attributes[1];
        office_to_process.num_seats = parseInt(office_attributes[2]);
        office_to_process.type = office_attributes[3];
        office_to_process.year = parseInt(office_attributes[4]);
        office_to_process.stages = stages;
         
        let response = await this.executeProcedure(
          "data_correction/split_race",
          JSON.stringify(office_to_process),
          { lockExecuteButton: true }
        );

         
        if (response['data']){
        this.split_races_created.push(response["data"][0]["split_races"])
        } else {
          this.split_races_created.push(response.message)
        }
      }
      
    },
    async deleteCandidates() {
      let delete_params = {
        candidates_to_delete: this.candidate_ids
        
      };
      
      this.candidate_response = await this.executeProcedure(
        "data_correction/delete_candidates",
        JSON.stringify(delete_params),
        { lockExecuteButton: true }
      );
      
    },
    async deleteRaces() {
     
       let delete_params = {
        races_to_delete: this.race_ids 
        
      };
       
      this.race_response = await this.executeProcedure(
        "data_correction/delete_races",
        JSON.stringify(delete_params),
        { lockExecuteButton: true }
      );
      
    },
  },

  mounted: async function () {
    this.selected = "";
    this.reset();
  },
};
</script>
<style scoped>
.modal-container {
  width: 75%;
  margin: 20px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;

  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}
.modal-container .btn {
  margin: 0 auto;
}
.modal-body {
  margin: 20px 0;
  white-space: pre-line;
}
.modal-default-button {
  margin: 0 auto;
}
.result-div {
  border-width: 1px;
  border-style: solid;
  border-color: black;
  margin-bottom: 15px;
}
.action-results {
  font-size: 1.25em;
}
.disclaimer-execute {
  text-align: center;
  margin-top: 10px;
}
.merge-people-table {
  margin-top: 15px;
}
</style>
